/**
 * Handles the error globally
 * Sample: errHandler(e, this.$toasted, key => this.$t(key))
 *
 * @param error
 * @param $toasted
 * @param $t
 */
export const errHandler = (error, $toasted, $t) => {
  if (typeof error.response !== 'undefined') {
    $toasted.global.error_message({
      message: error.response.data.errors.message
    })
  } else if (typeof error === 'string') {
    $toasted.global.error_message({
      message: $t(error)
    })
  } else {
    $toasted.global.error_message({
      message: $t('errors.*')
    })
  }
}
